let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gp0Qj")).then(() => parcelRequire('2qJyh'));